import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Component } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';


import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import {ScrollingModule} from '@angular/cdk/scrolling';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { PortalModule } from '@angular/cdk/portal';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { InitialPageComponent } from './pages/initial-page/initial-page.component';
import { SubmenuComponent } from './pages/modals/submenu/submenu.component';
import { AuthInterceptorService } from './services/auth-interceptor.service';

import { CommonModule } from '@angular/common';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { HeaderCalendar } from './components/modules/maintenance/calendar/header-calendar/module';
import { AlertComponent } from './components/modules/notifications/alert/alert.component';
import { CveEquipoComponent } from './components/modules/maintenance/equipment/cve-equipo/cve-equipo.component';
import { NgChartsModule } from 'ng2-charts';


import { TestComponent } from './tester/test/test.component';
import { FixedNotificationComponent } from './components/shared/fixed-notification/fixed-notification.component';
import { ScheduledComponent } from './components/modules/maintenance/calendar/scheduled/scheduled.component';

import { FlatpickrModule } from 'angularx-flatpickr';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { CalendarComponent } from './components/modules/maintenance/calendar/calendar/calendar.component';
import { FuelOrderDetailComponent } from './components/modules/fuel/fuel-order/fuel-order-detail/fuel-order-detail.component';
import { IndicatorsFuelComponent } from './components/modules/indicators/indicators-fuel/indicators-fuel.component';
import { IndicatorsMaintenanceComponent } from './components/modules/indicators/indicators-maintenance/indicators-maintenance.component';
import { SideBarComponent } from './components/shared/side-bar/side-bar.component';
import { InventoryComponent } from './components/modules/inventory/inventory/inventory.component';
import { InputsDetailsComponent } from './components/modules/inventory/inputs/inputs-details/inputs-details.component';
import { InitalPageDesktopComponent } from './pages/initial-page/inital-page-desktop/inital-page-desktop.component';
import { InitalPageMobileComponent } from './pages/initial-page/inital-page-mobile/inital-page-mobile.component';
import { HandlerItemsComponent, DialogDetailsList } from './components/shared/handler-items/handler-items.component';
import { OutputsDetailsComponent } from './components/modules/inventory/outputs/outputs-details/outputs-details.component';
import { UpgradePlanComponent } from './pages/upgrade-plan/upgrade-plan.component';
import { StorerRequestComponent } from './components/modules/notifications/storer-request/storer-request.component';
import { GenericNotificationComponent } from './components/modules/notifications/generic-notification/generic-notification.component';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { DetailsPurchaseOrderComponent } from './components/modules/inventory/purchase-order/details-purchase-order/details-purchase-order.component';
import { AuthorizePurchaseOrderComponent } from './components/modules/notifications/authorize-purchase-order/authorize-purchase-order.component';
import { WorkOrderSummaryComponent } from './components/modules/maintenance/maintenance-history/work-order-summary/work-order-summary.component';
import { IndicatorsInventoryComponent } from './components/modules/indicators/indicators-inventory/indicators-inventory.component';
import { ThousandSeparatorDirective } from './directives/thousand-separator.directive';
import { PermissionsDetailComponent } from './components/modules/human-resources/permissions/permissions-detail/permissions-detail.component';
import { PermissionsComponent } from './components/modules/human-resources/permissions/permissions.component';
import { MemosComponent } from './components/modules/human-resources/memos/memos.component';
import { MemosDetailComponent } from './components/modules/human-resources/memos/memos-detail/memos-detail.component';
import { DisabilitiesComponent } from './components/modules/human-resources/disabilities/disabilities.component';
import { DisabilitiesDetailComponent } from './components/modules/human-resources/disabilities/disabilities-detail/disabilities-detail.component';
import { DataRoMaintenanceOrdersComponent } from './components/modules/root/data-root/data-root.component';
import { AreasComponent } from './components/modules/administration/areas/areas.component';
import { AreaDetailComponent } from './components/modules/administration/areas/area-detail/area-detail.component';
import { AdministrationDataComponent } from './components/modules/administration/administration-data/administration-data.component';
import { ModalTypesComponent } from './components/shared/modals-types/modal-types.component';
import { ProfileComponent } from './components/modules/administration/profile/profile.component';
import { ModalProfileComponent } from './components/modules/administration/profile/modal-profile/modal-profile.component';
import { ProvidersComponent } from './components/modules/administration/providers/providers.component';
import { ProvidersDetailComponent } from './components/modules/administration/providers/providers-detail/providers-detail.component';
import { UsersComponent } from './components/modules/administration/users/users.component';
import { UserDetailComponent } from './components/modules/administration/users/user-detail/user-detail.component';
import { FuelHistoryComponent } from './components/modules/fuel/fuel-history/fuel-history.component';
import { FuelOrderComponent } from './components/modules/fuel/fuel-order/fuel-order.component';
import { FuelHistoryDetailComponent } from './components/modules/fuel/fuel-history/fuel-history-detail/fuel-history-detail.component';
import { FuelRequestsComponent } from './components/modules/fuel/fuel-requests/fuel-requests.component';
import { DateComponent } from './components/shared/date/date.component';
import { IndicadoresComponent } from './components/modules/indicators/shared/indicadores.component';
import { AuthorizeWorkOrderComponent } from './components/modules/notifications/authorize-work-order/authorize-work-order.component';
import { MaintenanceExecutionComponent } from './components/modules/notifications/maintenance-execution/maintenance-execution.component';
import { MaintenanceRequestNotificationComponent } from './components/modules/notifications/maintenance-request-notification/maintenance-request-notification.component';
import { FuelRequestsNotificationComponent } from './components/modules/notifications/fuel-requests-notification/fuel-requests-notification.component';
import { FuelOrderNotificationComponent } from './components/modules/notifications/fuel-order-notification/fuel-order-notification.component';
import { ActivitiesComponent } from './components/modules/maintenance/activities/activities.component';
import { ActivitieDetailComponent } from './components/modules/maintenance/activities/activitie-detail/activitie-detail.component';
import { ModalCalendarComponent } from './components/modules/maintenance/calendar/modal-calendar/modal-calendar.component';
import { MaintenanceOrdersComponent } from './components/modules/maintenance/maintenance-orders/maintenance-orders/maintenance-orders.component';
import { ModalMaintenanceOrdersComponent } from './components/modules/maintenance/maintenance-orders/maintenance-orders/modal-maintenace-orders/modal-maintenace-orders.component';
import { MaintenanceOrdersExecutionComponent } from './components/modules/maintenance/maintenance-orders/maintenance-orders-execution/maintenance-orders-execution.component';
import { MaintenaceOrderDetailComponent } from './components/modules/maintenance/maintenance-orders/maintenance-orders/maintenace-order-detail/maintenace-order-detail.component';
import { MaintenanceOrdersDispatchComponent } from './components/modules/maintenance/maintenance-orders/maintenance-orders-dispatch/maintenance-orders-dispatch.component';
import { EquipmentComponent } from './components/modules/maintenance/equipment/equipment.component';
import { MaintenanceHistoryComponent } from './components/modules/maintenance/maintenance-history/maintenance-history.component';
import { EquipmentDetailComponent } from './components/modules/maintenance/equipment/equipment-detail/equipment-detail.component';
import { ModalEquipmentComponent } from './components/modules/maintenance/equipment/modal-equipment/modal-equipment.component';
import { FillInspectionComponent } from './components/modules/inspections/fill-inspection/fill-inspection.component';
import { QuestionsComponent } from './components/modules/inspections/generic-question/questions/questions.component';
import { MaintenanceRequestComponent } from './components/modules/maintenance/maintenance-request/maintenance-request.component';
import { MaintenanceRegisterComponent } from './components/modules/maintenance/maintenance-register/maintenance-register.component';
import { InspectionHistoryComponent } from './components/modules/inspections/inspection-history/inspection-history.component';
import { OutputsComponent } from './components/modules/inventory/outputs/outputs.component';
import { InputsComponent } from './components/modules/inventory/inputs/inputs.component';
import { PurchaseOrderComponent } from './components/modules/inventory/purchase-order/purchase-order.component';
import { ModalHistoryComponent } from './components/modules/maintenance/maintenance-history/modal-maintenance-history/modal-maintenance-history.component';
import { CompaniesComponent } from './components/modules/root/companies/companies.component';
import { FormCompanyComponent } from './components/modules/root/companies/form-company/form-company.component';
import { ModalCompanyComponent } from './components/modules/root/companies/modal-company/modal-company.component';
import { ManagementDataComponent } from './components/modules/root/management-data/management-data.component';
import { PlansComponent } from './components/modules/root/plans/plans.component';
import { BrainloperUiModule } from 'brainloper-ui';
import { RouterComponent } from './components/modules/localization/router/router.component';
import { RouterDetailComponent } from './components/modules/localization/router/detail/router-detail.component';
import { ControlPointerComponent } from './components/modules/localization/shared/control-pointer/control-pointer.component';
import { HandlerRouterComponent } from './components/modules/localization/handler-router/handler-router.component';
import { EquipmentTableComponent } from './components/shared/tables/equipment-table/equipment-table.component';
import { TravelHistoryComponent } from './components/modules/localization/travel-history/travel-history.component';
import { TravelHistorySummaryComponent } from './components/modules/localization/travel-history/travel-history-summary/travel-history-summary.component';
import { ThousandSeparatorPipe } from './pipes/thousand-separator.pipe';
import { WarehouseComponent } from './components/modules/inventory/warehouse/warehouse.component';
import { MapComponent } from './components/shared/map/map.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { PushNotificationsService } from './services/push-notifications.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';


import { UserEntryRecordComponent } from './components/modules/human-resources/user-entry-record/user-entry-record.component';
import { DetailsRentalOrderComponent } from './components/modules/rental/rental-order/details-rental-order/details-rental-order.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { RentalEquipmentsComponent } from './components/modules/rental/rental-equipments/rental-equipments.component';
import { RentalIncomeDispatchComponent } from './components/modules/rental/rental-income-dispatch/rental-income-dispatch.component';
import { ModalRentalOrderComponent } from './components/modules/rental/rental-order/modal-rental-order/modal-rental-order.component';
import { RentalOrderSummaryComponent } from './components/modules/rental/rental-order/rental-order-summary/rental-order-summary.component';
import { RentalOrderComponent } from './components/modules/rental/rental-order/rental-order.component';
import { UserEntryRecordDetailComponent } from './components/modules/human-resources/user-entry-record/user-entry-record-detail/user-entry-record-detail.component';
import { CloseOrderComponent } from './components/shared/workOrder/close-order/close-order.component';
import { DevicesComponent } from './components/modules/localization/devices/devices.component';
import { ModalAddDevicesComponent } from './components/modules/localization/modal-add-devices/modal-add-devices.component';
import { InspectionFormComponent } from './components/modules/inspections/inspection-form/inspection-form.component';
import { InspectionFormDetailComponent } from './components/modules/inspections/inspection-form/inspection-form-detail/inspection-form-detail.component';
import { GenericQuestionComponent } from './components/modules/inspections/generic-question/generic-question.component';
import { ModalGenericQuestionComponent } from './components/modules/inspections/generic-question/modal-generic-question/modal-generic-question.component';
import { ModalEquipmentFormComponent } from './components/modules/inspections/inspection-form/modal-equipment-form/modal-equipment-form.component';
import { ModalFilesComponent } from './components/shared/modal-files/modal-files.component';
import { QuestionsBankComponent } from './components/modules/inspections/questions-bank/questions-bank.component';
import { AttachedInformationComponent } from './components/modules/notifications/attached-information/attached-information.component';
import { LogsComponent } from './components/modules/root/logs/logs.component';


registerLocaleData(localeEs);

@NgModule({
    declarations: [
        AppComponent,
        InitialPageComponent,
        SubmenuComponent,
        UsersComponent,
        ProvidersComponent,
        UserDetailComponent,
        ProvidersDetailComponent,
        ModalTypesComponent,
        AdministrationDataComponent,
        LoginPageComponent,
        ProfileComponent,
        ModalProfileComponent,
        AreasComponent,
        AreaDetailComponent,
        DisabilitiesComponent,
        PermissionsComponent,
        MemosComponent,
        MemosDetailComponent,
        PermissionsDetailComponent,
        DisabilitiesDetailComponent,
        EquipmentComponent,
        MaintenanceOrdersComponent,
        ActivitiesComponent,
        MaintenanceHistoryComponent,
        IndicadoresComponent,
        EquipmentDetailComponent,
        ModalEquipmentComponent,
        ModalMaintenanceOrdersComponent,
        ModalCalendarComponent,
        MaintenanceOrdersExecutionComponent,
        MaintenaceOrderDetailComponent,
        FillInspectionComponent,
        QuestionsComponent,
        DataRoMaintenanceOrdersComponent,
        MaintenanceRequestComponent,
        AuthorizeWorkOrderComponent,
        MaintenanceRequestNotificationComponent,
        MaintenanceExecutionComponent,
        ModalHistoryComponent,
        AlertComponent,
        MaintenanceRegisterComponent,
        CveEquipoComponent,
        FuelRequestsComponent,
        FuelHistoryComponent,
        CompaniesComponent,
        TestComponent,
        FixedNotificationComponent,
        FormCompanyComponent,
        ModalCompanyComponent,
        ManagementDataComponent,
        ScheduledComponent,
        CalendarComponent,
        FuelRequestsNotificationComponent,
        FuelOrderComponent,
        FuelOrderDetailComponent,
        FuelOrderNotificationComponent,
        FuelHistoryDetailComponent,
        PlansComponent,
        IndicatorsFuelComponent,
        IndicatorsMaintenanceComponent,
        SideBarComponent,
        InventoryComponent,
        OutputsComponent,
        InputsComponent,
        InputsDetailsComponent,
        DialogDetailsList,
        InitalPageDesktopComponent,
        InitalPageMobileComponent,
        InspectionHistoryComponent,
        HandlerItemsComponent,
        OutputsDetailsComponent,
        UpgradePlanComponent,
        StorerRequestComponent,
        MaintenanceOrdersDispatchComponent,
        GenericNotificationComponent,
        DateFormatPipe,
        PurchaseOrderComponent,
        DetailsPurchaseOrderComponent,
        AuthorizePurchaseOrderComponent,
        WorkOrderSummaryComponent,
        ActivitieDetailComponent,
        DateFormatPipe,
        IndicatorsInventoryComponent,
        ThousandSeparatorDirective,
        DateComponent,
        RouterComponent,
        RouterDetailComponent,
        ControlPointerComponent,
        HandlerRouterComponent,
        EquipmentTableComponent,
        TravelHistoryComponent,
        TravelHistorySummaryComponent,
        ThousandSeparatorPipe,
        WarehouseComponent,
        MapComponent,
        UserEntryRecordComponent,
        RentalOrderComponent,
        DetailsRentalOrderComponent,
        RentalEquipmentsComponent,
        RentalIncomeDispatchComponent,
        ModalRentalOrderComponent,
        RentalOrderSummaryComponent,
        UserEntryRecordDetailComponent,
        CloseOrderComponent,
        DevicesComponent,
        ModalAddDevicesComponent,
        QuestionsBankComponent,
        InspectionFormComponent,
        InspectionFormDetailComponent,
        GenericQuestionComponent,
        ModalGenericQuestionComponent,
        ModalEquipmentFormComponent,
        ModalFilesComponent,
        AttachedInformationComponent,
        LogsComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        NgChartsModule,
        BrainloperUiModule,
        NgbModule,
        BrowserAnimationsModule,
        HttpClientModule,
        ScrollingModule,
        ReactiveFormsModule,
        FormsModule,
        A11yModule,
        ClipboardModule,
        CdkStepperModule,
        CdkTableModule,
        CdkTreeModule,
        DragDropModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatStepperModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatTreeModule,
        PortalModule,
        CommonModule,
        NgbModalModule,
        HeaderCalendar,
        FlatpickrModule.forRoot(),
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        GoogleMapsModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
          //enabled: environment.production, // queda apagado pero se debe validar cunado se quiera realizar notificcaciones push
          enabled: false,
          // Register the ServiceWorker as soon as the application is stable
          // or after 30 seconds (whichever comes first).
          registrationStrategy: 'registerWhenStable:30000'
        }),
        NgxMaterialTimepickerModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
          enabled: environment.production,
          // Register the ServiceWorker as soon as the application is stable
          // or after 30 seconds (whichever comes first).
          registrationStrategy: 'registerWhenStable:30000'
        })
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true
        },
        PushNotificationsService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
